/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Trophy from './trophy-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Trophy {...validProps} />;
}
SvgComponent.iconName = 'trophy';

export const TrophyIcon = svgIconWrapper(SvgComponent);
